import styled from 'styled-components'

export const Sidebar = styled.aside`
    width: 240px;
    background: #eef3fb;
    border-radius: 16px;
    padding: 18px;
    box-shadow: inset 0 0 0 1px #d8e3f2;

    @media (max-width: 1000px) {
        width: 100%;
    }
`

export const SidebarLabel = styled.label`
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: #39598a;
    margin-bottom: 12px;
`

export const TableSelect = styled.select`
    width: 100%;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid #cfd9ea;
    background: white;
    font-size: 16px;
    color: #2d4a78;
    outline: none;
    cursor: pointer;
`
